import React,{useState} from "react";
import './hospital&doctormodal.css';

const AddHospitalCityModal=({show,onClose,onSave})=>{
    const[hospitalCity,sethospitalCity]=useState('');
if(!show){
    return null;
}
    const handleSave = () => {
        if(hospitalCity.trim()==='')
            {alert("hospital city Name cannot be empty")
                return
            }
        onSave(hospitalCity);
        sethospitalCity('');
        onClose();
      };



    return (
        <div className="modal-backdrop">
          <div className="modal-container">
            <div className="modal-header">
              <h2 className="modal-title">Add New Hospital City</h2>
              <button className="close-button" onClick={onClose}>&times;</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Hospital City Name:</label>
                <input
                  type="text"
                  value={hospitalCity}
                  onChange={(e) => sethospitalCity(e.target.value)}
                  className="modal-input"
                  placeholder="Enter hospital name"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-submit" onClick={handleSave}>Save</button>
              {/* <button className="modal-cancel" onClick={onClose}>Cancel</button> */}
            </div>
          </div>
        </div>
      );
    };
    
    export default AddHospitalCityModal;
    